import { Component } from 'react'
import SomeOrderProperties from '~/components/OrdersPage/SomeOrderProperties'
import CustomerProperties from '~/components/OrdersPage/CustomerProperties'
import DeliveryProperties from '~/components/OrdersPage/DeliveryProperties'
import styles from '~/styles/ordersPage.orderProperties.module.css'
import types from '~/types/ordersPage.ts'

export default class OrderProperties extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders', 'common' ],
		}
	}
	
	constructor(props) {
		super(props)
		this.state = {
			arePointsLoading: false,
			isEmptyResult: false,
		}
	}
	
	render(): JSX.Element {
		return (
			<div
				className={styles.main}
			>
				<div
					className={styles.someOrderValues}
				>
					<div
						className={styles.body}
					>
						<SomeOrderProperties
							order={this.props.order}
							editTheOrder={this.props.editTheOrder}
							onWarningChange={this.props.onWarningChange}
							setPointsLoading={this._setPointsLoading.bind(this)}
							setEmptyResult={this._setEmptyResult.bind(this)}
							setChargeableWeightUpdater={this.props.setChargeableWeightUpdater}
							setShipperUpdater={this.props.setShipperUpdater}
							t={this.props.t}
							isRu={this.props.isRu}
						/>
					</div>
				</div>
				<div
					className={styles.customer}
				>
					<div
						className={styles.title}
					>
						{this.props.t('Customer')}
					</div>
					<div
						className={styles.body}
					>
						<CustomerProperties
							order={this.props.order}
							editTheOrder={this.props.editTheOrder}
							showMap={this.props.showMap}
							setPointsLoading={this._setPointsLoading.bind(this)}
							setEmptyResult={this._setEmptyResult.bind(this)}
							chargeableWeightUpdater={this.props.chargeableWeightUpdater}
							t={this.props.t}
							currentDealer={this.props.currentDealer}
							isRu={this.props.isRu}
						/>
					</div>
				</div>
				<div
					className={styles.delivery}
				>
					<div
						className={styles.title}
					>
						{this.props.t('Delivery')}
					</div>
					<div
						className={styles.body}
					>
						<DeliveryProperties
							order={this.props.order}
							editTheOrder={this.props.editTheOrder}
							showMap={this.props.showMap}
							arePointsLoading={this.state.arePointsLoading}
							isEmptyResult={this.state.isEmptyResult}
							chargeableWeightUpdater={this.props.chargeableWeightUpdater}
							t={this.props.t}
							isRu={this.props.isRu}
						/>
					</div>
				</div>
			</div>
		)
	}

	private _setPointsLoading(arePointsLoading: boolean) {
		this.setState({ arePointsLoading })
	}

	private _setEmptyResult(isEmptyResult: boolean) {
		this.setState({ isEmptyResult })
	}
}